<template>
  <div class="top">
    <Top :items="items"></Top>
  </div>
</template>

<script>
import Top from "../components/pages/Top";

export default {
  name: "TopView",
  components: {
    Top,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
